import { Col, Row } from "antd";
import { useEffect, useState } from "react";
import CategoryManagementCard from "../../../components/configuration/CategoryManagementCard";
import ItemDetailsCard from "../../../components/configuration/ItemDetailsCard";
import useGetCategoryConfig from "../../../functions/Category/getCategoryConfig";
import useManageCategoryItem from "../../../functions/Category/manageCategoryItem";

export default function FoodPage() {
  const { category, getCategoryConfig } = useGetCategoryConfig();
  const [categories, setCategories] = useState([]);
  const [selectedId, setSelectedId] = useState(null);
  const [editingId, setEditingId] = useState("");

  const { manageCategoryItem } = useManageCategoryItem();

  useEffect(() => {
    if (category && category.length > 0) {
      const dataStructure = category
        .sort((a, b) => a.sequence - b.sequence)
        .map((cat) => ({
          id: cat.id,
          name: cat.label,
          isRemoved: cat.is_removed,
          items: cat.children.map((item) => ({
            id: item.id,
            name: item.label,
            price: item.unit_price,
            sequence: item.sequence,
          })),
        }));
      setCategories(dataStructure);
    }
  }, [category]);

  const selectedCategory = categories.find((item) => item.id === selectedId);
  const handleSelectCategory = (id) => {
    setSelectedId(id);
    setEditingId("");
  };

  return (
    <Row gutter={[16, 16]} style={{ height: "calc(100vh - 80px)" }}>
      <Col span={11}>
        <CategoryManagementCard
          categories={categories}
          selectedId={selectedCategory ? selectedCategory.id : null}
          handleSelectCategory={handleSelectCategory}
          manageCategoryItem={manageCategoryItem}
          getCategoryConfig={getCategoryConfig}
          disabled={!!editingId}
        />
      </Col>
      <Col span={13}>
        <ItemDetailsCard
          selectedCategory={selectedCategory}
          onClearSelection={() => setSelectedId(null)}
          manageCategoryItem={manageCategoryItem}
          getCategoryConfig={getCategoryConfig}
          editingId={editingId}
          setEditingId={setEditingId}
        />
      </Col>
    </Row>
  );
}
